import { render } from "./DirectInputAge.vue?vue&type=template&id=bcc6d9e4&scoped=true"
import script from "./DirectInputAge.vue?vue&type=script&lang=js"
export * from "./DirectInputAge.vue?vue&type=script&lang=js"

import "./DirectInputAge.vue?vue&type=style&index=0&id=bcc6d9e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc6d9e4"],['__file',"src/components/DirectInputAge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcc6d9e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcc6d9e4', __exports__)) {
    api.reload('bcc6d9e4', __exports__)
  }
  
  module.hot.accept("./DirectInputAge.vue?vue&type=template&id=bcc6d9e4&scoped=true", () => {
    api.rerender('bcc6d9e4', render)
  })

}


export default __exports__